import React, { useState, useEffect } from "react";

import "./stylesMarketTypes.css";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import RebetLoader from "../../../../CommonComponents/RebetLoader/RebetLoader";
import createPrivateAdminPanelInstance from "../../../../../api/PrivateAdminPanelInstance";
import { useSearchParams } from "react-router-dom";
import { API_ROUTES } from "../../../../../api/ApiRoutes";
import { AppStrings } from "../../../../../utils/constants/AppStrings";

ChartJS.register(ArcElement, Tooltip, Legend);

const options = {
  plugins: {
    legend: {
      display: false,
    },
    datalabels: {
      display: false,
    },
    tooltip: {
      enabled: true,
      backgroundColor: "#252729",
      titleFont: {
        family: "Poppins-regular",
        size: 16,
        weight: "bold",
      },
      bodyFont: {
        family: "Poppins-regular",
        size: 14,
      },
      padding: 15,
      displayColors: true,
      callbacks: {
        label: function (tooltipItem) {
          const label = tooltipItem.dataset.label || "";
          const value = tooltipItem.raw;
          return `${label}: ${Intl.NumberFormat("en-US").format(value)}`;
        },
      },
    },
  },
};

const colors = [
  "#3498DB",
  "#6177E8",
  "#9B59B6",
  "#E74C3C",
  "#F1C40F",
  "#2ECC71",
  "#943126",
  "#1ABC9C",
  "#E67E22",
];

function MarketTypes() {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
    false
  );

  const [searchParams] = useSearchParams();
  const eventId = searchParams.get("event-id");

  const [isApiRunning, setIsApiRunning] = useState(false);

  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        label: false,
        data: [],
        backgroundColor: colors,
        borderColor: colors,
        borderWidth: 1,
      },
    ],
  });
  const labels = chartData?.labels;

  const getMarketTypes = async () => {
    setIsApiRunning(true);
    try {
      const requests = [
        PrivateAdminPanelInstance.post(
          API_ROUTES.GET_EVENT_DETAILS_KPI_MARKET_TYPES,
          { event_id: eventId, provider: "sportradar" }
        ),
      ];

      const responses = await Promise.allSettled(requests);
      const [sportradarResponse] = responses;

      if (sportradarResponse.status === "fulfilled") {
        const data = sportradarResponse?.value?.data?.data?.data || [];

        console.log("data marketTypes", data);

        const labels = data.map((item) => item.label);
        const values = data.map((item) => item.value);

        setChartData({
          labels: labels,
          datasets: [
            {
              label: false,
              data: values,
              backgroundColor: colors,
              borderColor: colors,
              borderWidth: 1,
            },
          ],
        });
      }
    } catch (error) {
      console.log("Error getting bet types:", error);
    } finally {
      setIsApiRunning(false);
    }
  };

  useEffect(() => {
    getMarketTypes();
  }, []);

  return (
    <div className="market-types-container">
      <div className="market-types-header">
        <h2>{AppStrings.MARKET_TYPES}</h2>
      </div>
      <div className="market-types-content">
        {isApiRunning ? (
          <RebetLoader width={100} height={100} />
        ) : (
          <>
            <div className="market-types-chart">
              <Pie data={chartData} options={options} />
            </div>
            <div className="market-types-legend">
              {labels.map((label, index) => (
                <div className="market-types-legend-item" key={index}>
                  <div
                    className="market-types-legend-item-color"
                    style={{ backgroundColor: colors[index] }}
                  />
                  <span className="market-types-legend-item-label">
                    {label}
                  </span>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default MarketTypes;
